import React from 'react';

const LoaderLockerComponent = React.memo(() => (
  <div
    className="is-overlay smart-maps-locker"
    style={{ opacity: 0.85, zIndex: 0 }}
  />
));

LoaderLockerComponent.displayName = 'LoaderLockerComponent';

export default LoaderLockerComponent;
